module.exports = __webpack_public_path__ + "static/media/Screwdriver Wrench.795d4f09.svg";